var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('input',{staticClass:"mycheck",attrs:{"type":"checkbox"},domProps:{"checked":_vm.params.value},on:{"click":function($event){return _vm.checkedHandler($event)}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }